import assign from "lodash.assign";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function digitalSubscription(product: string, data: {[s: string]: any}): {[s: string]: any} {
    return assign({}, { product, type: "DIGITAL" }, data);
}

export const businessweekData = digitalSubscription.bind(null, "BW");
export const bbgData = digitalSubscription.bind(null, "BBG");

export default {
    businessweekData,
    bbgData
};
